var OnetrustActiveGroups = window.OnetrustActiveGroups || '';

(function ($, Drupal, Optanon) {
  Drupal.behaviors.SheerIDBlockV1 = {
    getButtons: function ($module) {
      var $triggers = $('.js-elc-button', $module);

      if ($triggers.length > 0) {
        $triggers = $triggers.eq(0);
      }

      return $triggers;
    },

    getImage: function ($module) {
      return $('.js-sheerid-block-link-image', $module);
    },

    attach: function (context) {
      var self = this;
      var $modules = $('.js-sheerid-block--v1', context);

      $modules.each(function () {
        self.init($(this));
      });
    },

    init: function ($module) {
      // Check for onetrust/optanon/onetrustgroups to determine if we need, have or denied consent.
      var cookieAllowedOrIgnored = () => {
        return (
          !Drupal.settings.onetrust_enabled ||
          (OnetrustActiveGroups && OnetrustActiveGroups.includes(',3,'))
        );
      };
      var cookieConsentChangeCallback = () => {
        var self = this;
        if (cookieAllowedOrIgnored()) {
          self.render($module);
        }
      };

      if (Optanon) {
        Optanon.OnConsentChanged(cookieConsentChangeCallback);
      }
      site.elcEvents.addListener('onetrust:loaded', cookieConsentChangeCallback);
      cookieConsentChangeCallback();
    },

    render: function ($module) {
      var self = this;
      var $script = $module.find('.js-sheerid-script');
      var verificationUrl = $script.data('verificationUrl');
      var elementsToListen = [];

      elementsToListen.push(self.getButtons($module));
      elementsToListen.push(self.getImage($module));
      $script.on('load', function () {
        elementsToListen.forEach(function (element) {
          $(element)
            .off('click.sheerID')
            .on('click.sheerID', function (event) {
              event.preventDefault();
              sheerId.loadInModal(verificationUrl, { mobileRedirect: true });
            });
        });
      });
      $module.removeClass('hidden');
      $script.attr('src', $script.data('src'));
    }
  };
})(jQuery, Drupal, window.Optanon);
